export const NewClass = 'btn btn-sm btn-primary';
export const InitializedClass = 'btn btn-sm Initilaized';
export const ReadyClass = 'btn btn-sm btn-warning';
export const CompletedClass = 'btn btn-sm btn-success';
export const FailedClass = 'btn btn-sm btn-danger';
export const ErrorClass = 'btn btn-sm btn-dark';
export const NotRequiredClass = 'btn btn-sm btn-secondary';
export const InProcessClass = 'btn btn-sm btn-secondary';